import React from 'react';
import { useIntl } from 'react-intl';

import { EmptyState } from '../EmptyState';
import { Button } from '../Button';
import { Icons } from '../Icons';
import messages from './messages';

type Props = {
  title: string;
  description: string;
  reloadText: string;
  errorStatus?: number;
  entity?: string;
  onClick?: () => void;
};

const ErrorState = ({
  title,
  description,
  reloadText,
  errorStatus,
  entity,
  onClick,
}: Props) => {
  const { formatMessage } = useIntl();

  const handleOnReloadClick = () => {
    window.location.reload();
  };

  const errorDescription = errorStatus
    ? formatMessage(messages[errorStatus], {
        entity,
      })
    : description;

  return (
    <EmptyState
      variant="page"
      visual={<Icons.Alert color="red" size="60px" />}
      title={title}
      description={errorDescription}
      buttons={
        onClick || !errorStatus ? (
          <Button
            onClick={onClick || handleOnReloadClick}
            aria-label="reload page"
          >
            {reloadText}
          </Button>
        ) : null
      }
    />
  );
};

export { ErrorState };
